import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * EventSubscriptionsApi - axios parameter creator
 * @export
 */
const EventSubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {BackInStockSubscriptionToken} [BackInStockSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backInStockSubscription: async (BackInStockSubscriptionToken, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/BackInStockSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BackInStockSubscriptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Double opt-in confirmation link target. Idempotent: the token is kept, because mail scanners open the link before the customer does.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBackInStock: async (token, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/ConfirmBackInStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (EventSubscriptionToken, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(EventSubscriptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (EventSubscriptionToken, options = {}) => {
            const localVarPath = `/v1/EventSubscriptions/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(EventSubscriptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventSubscriptionsApi - functional programming interface
 * @export
 */
const EventSubscriptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventSubscriptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {BackInStockSubscriptionToken} [BackInStockSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backInStockSubscription(BackInStockSubscriptionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backInStockSubscription(BackInStockSubscriptionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.backInStockSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Double opt-in confirmation link target. Idempotent: the token is kept, because mail scanners open the link before the customer does.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmBackInStock(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmBackInStock(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.confirmBackInStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(EventSubscriptionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(EventSubscriptionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(EventSubscriptionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(EventSubscriptionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventSubscriptionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * EventSubscriptionsApi - factory interface
 * @export
 */
const EventSubscriptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventSubscriptionsApiFp(configuration);
    return {
        /**
         *
         * @param {BackInStockSubscriptionToken} [BackInStockSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backInStockSubscription(BackInStockSubscriptionToken, options) {
            return localVarFp.backInStockSubscription(BackInStockSubscriptionToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Double opt-in confirmation link target. Idempotent: the token is kept, because mail scanners open the link before the customer does.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBackInStock(token, options) {
            return localVarFp.confirmBackInStock(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(EventSubscriptionToken, options) {
            return localVarFp.insert(EventSubscriptionToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {EventSubscriptionToken} [EventSubscriptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(EventSubscriptionToken, options) {
            return localVarFp.update(EventSubscriptionToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventSubscriptionsApi - object-oriented interface
 * @export
 * @class EventSubscriptionsApi
 * @extends {BaseAPI}
 */
class EventSubscriptionsApi extends BaseAPI {
    /**
     *
     * @param {BackInStockSubscriptionToken} [BackInStockSubscriptionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    backInStockSubscription(BackInStockSubscriptionToken, options) {
        return EventSubscriptionsApiFp(this.configuration).backInStockSubscription(BackInStockSubscriptionToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Double opt-in confirmation link target. Idempotent: the token is kept, because mail scanners open the link before the customer does.
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    confirmBackInStock(token, options) {
        return EventSubscriptionsApiFp(this.configuration).confirmBackInStock(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    getAll(options) {
        return EventSubscriptionsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    getById(id, options) {
        return EventSubscriptionsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {EventSubscriptionToken} [EventSubscriptionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    insert(EventSubscriptionToken, options) {
        return EventSubscriptionsApiFp(this.configuration).insert(EventSubscriptionToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    remove(id, options) {
        return EventSubscriptionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {EventSubscriptionToken} [EventSubscriptionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSubscriptionsApi
     */
    update(EventSubscriptionToken, options) {
        return EventSubscriptionsApiFp(this.configuration).update(EventSubscriptionToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { EventSubscriptionsApi, EventSubscriptionsApiAxiosParamCreator, EventSubscriptionsApiFactory, EventSubscriptionsApiFp };
//# sourceMappingURL=event-subscriptions-api.js.map
